import { forwardRef } from "react";
import React from "react";

export const withVersions = <P extends object>(
  versions: Record<string, React.ComponentType<P> | any>,
) => {
  return forwardRef(
    (
      {
        version = process.env.REACT_APP_THEME_VERSION || "v1",
        ...props
      }: {
        version?: string;
      } & any,
      ref,
    ) => {
      const Component = versions[version];

      if (!Component) {
        throw new Error(`Component for version ${version} not found`);
      }

      return <Component {...props} ref={ref} />;
    },
  );
};
